import React, { useState } from "react";
import moment from "moment";

const futureMonths = {
  da: [
    "Januar",
    "Februar",
    "Marts",
    "April",
    "Maj",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "December",
  ],
  en: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
  de: [
    "Januar",
    "Februar",
    "März",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember",
  ],
};

const labels = {
  headline: {
    da: "Se hvilke pladser, der er i sæson",
    en: "See fishingspots in season",
    de: "Sehen Sie die Angelplätze in der Saison",
  },
  now: {
    da: "Nu",
    en: "Now",
    de: "Später",
  },
};

/*
 * This component allows the user to pick a month in the future
 */

const FutureMonths = (props) => {
  const [futureMonth, setFutureMonth] = useState(1);

  const monthElements = futureMonths[props.language].map((m, i) => (
    <span
      key={i}
      onClick={() => {
        setFutureMonth(i + 1);
        props.setFutureMode(true, moment().month(i));
      }}
      className={futureMonth === i + 1 && "active"}
    >
      {m}
    </span>
  ));

  return (
    <div>
      <div className="now modeSwitchButton" onClick={props.futureSwitch}>
        <span>{labels.now[props.language]}</span>
      </div>
      <div
        className="planner weatherDateContainer"
        data-bind="visible: futureMode"
      >
        <div className="header">{labels.headline[props.language]}</div>
        <div className="body">
          <div className="monthPicker">
            <div className="months">{monthElements}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FutureMonths;
